var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":("/day-wallets/settlement-detail/" + (_vm.row.id))}},[_c('i',{staticClass:"fas fa-cog"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }